import Button from 'react-bootstrap/Button'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
import Alert from 'react-bootstrap/Alert'
import { useEffect } from 'react'
import { useLocation } from "react-router-dom"
import { toasts, clearNotifications } from '../stores/notification-store'

const handleClose = (index) => {
    const filteredToasts = toasts.value.filter((t, i) => index != i)
    toasts.value = filteredToasts
}

function ToastItems() {
    let items = toasts.value.map((t, index) => {

        return (
            <Alert key={index} variant={t.type} onClose={() => handleClose(index)} dismissible className="my-2">
                <Alert.Heading>{t.headerMessage}</Alert.Heading>
                <p>{t.message}</p>
            </Alert>
        )
    })
    return items
}

export default function Notification() {

    const location = useLocation()
    useEffect(() => {
        clearNotifications()
    }, [location])

    if (toasts.value.length > 0) {
        return (
            <div>
                <ToastItems />
            </div>
        )
    }
};